<template>
    <div>
        <input
            :value="value" 
            @input="onInput"
            :placeholder="placeholder"
            class="common_input" 
            type="text"
        >
        <div v-if="isShowCount" class="count">{{ (value || '').length }}/{{ maxNum }}</div>
    </div>
</template>

<script>
export default {
    name: 'CountInput',
    props: {
        value: {
            type: String,
            default: ''
        },
        maxNum: {
            type: Number,
            default: 0
        },
        placeholder: {
            type: String,
            default: ''
        },
        isShowCount: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onInput(e) {
            let val = String(e.target.value || '')
            if (this.isShowCount) {
                if (val.length > this.maxNum) {
                    val = val.slice(0, this.maxNum)
                    e.target.value = val
                }
            } else {
                e.target.value = val
            }
            this.$emit('input', val)
        }
    }
}
</script>

<style scoped>
.count {
    margin-top: 6px; 
    font-weight: 700; 
    font-size: 12px; 
    color: #bbbbbb; 
    text-align: right;
}

.common_input {
    border-radius: 12px;
    height: 48px;
    background-color: #f5f5f5;
    width: 100%;
    border: none;
    padding: 0 12px;
    outline: none;
}

input::placeholder {
    font-size: 14px;
    font-weight: 500;
    color: #bbbbbb;
}
</style>